import {
  json as baseJson,
  info as baseInfo,
} from '../../Base/Signup_fortuneWheel'
import themeBase from './_themeBase'
import INDEX from './_index'

const info = JSON.parse(JSON.stringify(baseInfo))
const json = JSON.parse(JSON.stringify(baseJson))
const templateID = info.templateID + INDEX

info.templateID = templateID
info.priority = 40
info.name = 'Christmas: ' + info.name
json.templateID = templateID
json.theme = themeBase.theme

// Apply theme-specific styling overrides
json.styling = {
  ...json.styling,
  backgroundColor: '#FF0000', // Christmas red background
  // backgroundImage: 'url("https://assets.onvocado.com/templates/christmas-bg.jpg")',
}

// Set Christmas-themed font
const christmasFont = 'Shadows Into Light'

// Modify content items as needed
json.steps.forEach((step) => {
  step.contentItems = step.contentItems.map((item) => {
    if (item.type === 'headline') {
      item.content.text = 'Ho Ho Ho! Spin & Win This Christmas!'
      item.styling.fontFamily = christmasFont
      item.styling.fontSize = '32px'
    }
    if (item.type === 'text') {
      item.content.text = '<p>Santa has gifts for you! <strong>Spin the wheel</strong> and discover your Christmas surprise!</p>'
      item.styling.fontFamily = christmasFont
    }
    if (item.type === 'button') {
      item.content.text = 'Spin Now'
      item.styling.fontFamily = christmasFont
    }
    if (item.type === 'field' || item.type === 'voucher') {
      item.styling.fontFamily = christmasFont
    }
    return item
  })
})

export { json, info }